import { FileUpload, FileUploadStats } from './chat.types';
import { UploadId } from './upload.types';

export type KnowledgeBaseID = string;
export type KnowledgeBaseDocumentID = string;

export interface KnowledgeBase {
  id: KnowledgeBaseID;
  name: string;
  description: string;
  date: string;
}

export interface UserKnowledgeBase extends KnowledgeBase {
  messages: KBMessage[];
}

export interface AdminKnowledgeBase extends KnowledgeBase {
  number_of_documents: number;
  documents: KnowledgeBaseDocument[];
  status: KnowledgeBaseStatus;
}

export interface KnowledgeBaseDocument {
  id: KnowledgeBaseDocumentID;
  name: string;
  status: ExtractionStatus;
  date: string;
}

export interface IKnowledgeBaseState {
  knowledgeBases: Record<KnowledgeBaseID, UserKnowledgeBase>;
  activeKnowledgeBaseID: KnowledgeBaseID | null;
  adminKnowledgeBases: Record<KnowledgeBaseID, AdminKnowledgeBase>;
  activeAdminKnowledgeBaseID: KnowledgeBaseID | null;
  uploads: Record<UploadId, FileUploadStats>;
  uploaded: Record<UploadId, FileUpload>;
}

export interface KBMessage {
  id: string;
  role: KBMessageRole;
  date: string;
  parts: KBMessagePart[];
}

export interface KBMessagePart {
  type: KBMessagePartType;
  content: string | KBMessageSource | KBMessageAction | KBMessageACK;
}

export interface KBMessageSource {
  source_id: string;
  document_id: string;
  document: string;
  page: number;
  bboxes: number[][];
}

export interface KBMessageAction {
  action: string;
  table: number;
}

export interface KBMessageACK {
  id: string;
  role: KBMessageRole;
  date: string;
}

export enum KBMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export enum KBMessagePartType {
  TEXT = 'text',
  SOURCE = 'source',
  ACTION = 'action',
  ACK = 'ack',
}

export enum ExtractionStatus {
  Done = 'done',
  Failed = 'failed',
  Running = 'running',
  Empty = 'empty',
  Queued = 'queued',
}

export enum KnowledgeBaseStatus {
  Done = 'done',
  Failed = 'failed',
  Processing = 'processing',
}
